module.exports = __webpack_public_path__ + "media/images/icon-challanger-aed192d9a9fa1b48318e8438b716ae52.svg";